/**
 * Which described settings each settings page edits.
 *
 * The settings used to be one screen with a sub-menu of sixteen groups; they
 * now live on the page an operator would look for them on — the return window
 * under "Orders and checkout", the VAT rate under "Taxes", cash on delivery
 * beside the payment gateways. A test keeps every group in `SETTING_SECTIONS`
 * on exactly one page, so a new one cannot be left where nobody can reach it.
 */
export const SETTINGS_PAGES = {
  general: ['store.info', 'store.maintenance', 'company.legal', 'invoice.config', 'reports.targets'],
  checkout: ['order.policy', 'inventory.policy', 'returns.policy', 'digital.delivery', 'wallet.cashback'],
  customers: ['auth.login', 'customers.stages', 'support.config', 'trade.config', 'reviews.policy', 'loyalty.config', 'referrals.config'],
  catalog: ['catalog.display'],
  taxes: ['tax.config'],
  /** Beside the gateways on the payments page. */
  payments: ['payments.config'],
  /** Beside the zones on the shipping page. */
  shipping: ['shipping.config', 'shipping.carriers', 'shipping.calendar'],
  /** Beside the templates on the notifications page. */
  notifications: ['email.config'],
  /** The owner's own CSS and scripts (ADR-092). */
  customCode: ['storefront.code'],
} as const satisfies Record<string, readonly string[]>;

export type SettingsPageId = keyof typeof SETTINGS_PAGES;
